<template>
  <v-tooltip
    bottom
    :disabled="!creditorId || !tooltipText || !creditors.length"
  >
    <template v-slot:activator="{ on, attrs }">
      <small
        v-bind="attrs"
        v-on="on"
        class="creditor-number ml-1 mt-1 pa-1 "
      >
        {{ creditorId || "" }}
        <span class="font-weight-bold">
          {{ others.length ? `+${others.length}` : "" }}
        </span>
      </small>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CreditorChip",
  props: {
    creditorId: {
      type: Number,
      required: true,
    },
    creditors: {
      type: Array,
      required: false,
      default: () => [],
    },
    others: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  computed: {
    tooltipText() {
      const creditor = this.creditors.find(
        (c) => c.creditor_id === this.creditorId,
      );

      let tooltip = this.getCreditorName(this.creditorId);

      if (this.others.length) tooltip += '<br/>' + this.others.map((id) => this.getCreditorName(id)).join("<br/>");
      return tooltip;
    },
  },
  methods: {
    getCreditorName(id) {
      const creditor = this.creditors.find(
        (c) => c.creditor_id === id
      );
      return creditor ? `#${id} ${creditor.name}` : "Credor desconhecido";
    }
  }
};
</script>

<style lang="scss" scoped>
.creditor-number {
  background-color: #e0e0e0;
  border-radius: 10px;
  box-shadow: inset 0 -4px 8px -2px rgba(0, 0, 0, 0.22);
}
</style>
